import { CheckCircle2, TriangleAlert } from "lucide-react";
import { Spinner } from "@/components/ui/spinner";
import {
  SaveStatus as SaveStatusType,
  useAutoSaveContext
} from "../../contexts/AutoSaveContext";

type Props = {
  status: SaveStatusType;
};

export const SaveStatusComponent = ({ status }: Props) => {
  switch (status) {
    case "saving":
      return (
        <span className="inline-flex items-center gap-2 text-fg-3">
          <Spinner className="size-3" />
          <span className="text-sm">Saving</span>
        </span>
      );
    case "success":
      return (
        <span className="inline-flex items-center gap-2 text-success">
          <CheckCircle2 className="size-3" />
          <span className="text-sm">Saved</span>
        </span>
      );
    case "error":
      return (
        <span className="inline-flex items-center gap-2 text-danger">
          <TriangleAlert className="size-3" />
          <span className="text-sm">Failed to save</span>
        </span>
      );

    default:
      return null;
  }
};

export const AutoSaveIndicator: React.FC = () => {
  const { autoSaveStatus } = useAutoSaveContext();

  if (autoSaveStatus === "idle") return null;

  return (
    <div className="fixed right-9 bottom-4.5 z-1800">
      <span className="inline-flex h-6 items-center rounded-full bg-elevated px-2.5 shadow-popover ring-1 ring-line-3">
        <SaveStatusComponent status={autoSaveStatus} />
      </span>
    </div>
  );
};
